import { Moment } from 'moment';
import React, { FC } from 'react';
import { ResultsCount } from 'src/components/results-count';
import styled from 'styled-components';
import { IOrder, Status } from '../../graphql/types';
import { OrdersSearchControls } from './search-controls';
import { OrdersTable } from './table/table';

const StyledBottomSection = styled.div`
  padding: 4.5rem 7.5rem 4.5rem 7.5rem;
`;

const StyledSearch = styled.div`
  padding: 1rem 0rem 0rem 0rem;
`;

export const OrdersBody: FC<{
  orders: IOrder[];
  soldToId: string;
  shipToId?: string;
  startDate?: Moment;
  endDate?: Moment;
  statuses: Status[];
  showDatePill: boolean;
  vesseles: string[];
}> = ({
  orders,
  soldToId,
  shipToId,
  startDate,
  endDate,
  statuses,
  showDatePill,
  vesseles,
}) => {
  const orderswithVesselInfoCount = orders
    .filter(order => order?.partnerInfo !== null)
    .map(p => p.partnerInfo?.vesselName);

  const uniqueVessels = orderswithVesselInfoCount.filter((c, index) => {
    return orderswithVesselInfoCount.indexOf(c) === index;
  });

  let ordersFilteredByStatusAndVessel =
    statuses.length > 0
      ? orders.filter(order => statuses.includes(order.status))
      : orders;

  // Empty Check
  if (vesseles.length === 1 && vesseles.includes('Empty')) {
    ordersFilteredByStatusAndVessel =
      vesseles.length > 0
        ? ordersFilteredByStatusAndVessel.filter(order => !order.partnerInfo)
        : ordersFilteredByStatusAndVessel;
  } // Empty check with along with vessel name
  else if (
    vesseles.length !== uniqueVessels.length + 1 &&
    vesseles.includes('Empty')
  ) {
    const filterWithVessel =
      vesseles.length > 0
        ? ordersFilteredByStatusAndVessel.filter(order =>
            vesseles.includes(
              order.partnerInfo ? order.partnerInfo?.vesselName : ''
            )
          )
        : ordersFilteredByStatusAndVessel;
    const filterWithOutVessel =
      vesseles.length > 0
        ? ordersFilteredByStatusAndVessel.filter(order => !order.partnerInfo)
        : ordersFilteredByStatusAndVessel;
    ordersFilteredByStatusAndVessel = [
      ...filterWithVessel,
      ...filterWithOutVessel,
    ];
  } else if (
    // Select All Check
    vesseles.length === uniqueVessels.length + 1 &&
    vesseles.includes('Empty')
  ) {
    ordersFilteredByStatusAndVessel = [...ordersFilteredByStatusAndVessel];
  } else {
    ordersFilteredByStatusAndVessel =
      vesseles.length > 0
        ? ordersFilteredByStatusAndVessel.filter(order =>
            vesseles.includes(
              order.partnerInfo ? order.partnerInfo?.vesselName : ''
            )
          )
        : ordersFilteredByStatusAndVessel;
  }

  return (
    <>
      <StyledBottomSection>
        <StyledSearch>
          <ResultsCount
            label="Ship-To orders"
            count={ordersFilteredByStatusAndVessel.length || 0}
          />
          <OrdersSearchControls
            soldToId={soldToId}
            shipToId={shipToId}
            startDate={startDate}
            endDate={endDate}
            statuses={statuses}
            orders={orders}
            showDatePill={showDatePill}
            vesseles={vesseles}
          />
        </StyledSearch>
        <OrdersTable orders={ordersFilteredByStatusAndVessel} />
      </StyledBottomSection>
    </>
  );
};
